<template>
  <v-snackbar v-model="active" :timeout="options.timeout || 3000">
    {{ options.text || '' }}
    <template v-slot:action="{ attrs }">
      <v-btn :color="color" text v-bind="attrs" small @click="active = false">
        OK
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
export default {
  data: () => ({
    active: false,
    color: null,
    options: {
      text: null,
      timeout: null,
    },
  }),
  methods: {
    open(options) {
      this.options.text = null
      this.options.timeout = null

      this.options = Object.assign(this.options, options)
      this.active = true
    },
    success(options) {
      this.color = 'success'
      this.open(options)
    },
    error(options) {
      this.color = 'error'
      this.open(options)
    },
    checkAndOpenCommonLoadError(error) {
      if (error.status !== 403) {
        this.error({ text: this.$t('common.loadError') })
      }
    },
  },
}
</script>
